// The image shown in an upload slot before anything has been chosen.
//
// WHY THIS EXISTS: every form that uploads a picture had its own copy of the same
// hard-coded URL, pointing at `novathreadbucket` - a bucket left over from an earlier,
// unrelated project. Fourteen copies of a link to someone else's S3 bucket meant the
// placeholder was a network request on every form open, and would break for good the day
// that bucket was emptied or its permissions changed.
//
// It now ships with the app: no request, and no dependency on a bucket nobody owns.
//
// TO CHANGE THE PLACEHOLDER: drop the new file in src/assets and change the import below.
// Nothing else needs to change - all fourteen forms read this one value.
import placeholderImage from "../assets/dummy_image.jpg";

export const PLACEHOLDER_IMAGE = placeholderImage;

export default PLACEHOLDER_IMAGE;
